import {Directive, inject, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {environment} from '../../environments/environment.dev';


@Directive({
  selector: '[dev]'
})
export class DevDirective implements OnInit {
  private templateRef = inject(TemplateRef<unknown>);
  private viewContainer = inject(ViewContainerRef);

  ngOnInit() {
    if (!environment.production) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
